
<h1 mat-dialog-title="mat-dialog-title">Save Your Response Title</h1>
<div mat-dialog-content="mat-dialog-content">
  <mat-form-field>
    <input matInput="matInput" [(ngModel)]="title" name="title" placeholder="Enter title of the response...."/>
  </mat-form-field>
</div>
<div mat-dialog-actions="mat-dialog-actions">
  <button mat-raised-button="mat-raised-button" [mat-dialog-close]="title"> Done </button>
</div>